export default __webpack_public_path__ + "static/media/ifas_logo.48f594f9.png";